import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import PruefAssistenz from '../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const AusgangssituationAntragEbusseNachruestung: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<ApplicationHeading title='Ausgangssituation' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausgangssituation_Pruefstatus.path}
				hinweisPath={P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausgangssituation_Hinweis_Antragsteller.path}
				ueberarbeitetAmPath={P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausgangssituation_Ueberarbeitet_Am.path}
				erledigtPath={P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausgangssituation_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>

			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default AusgangssituationAntragEbusseNachruestung;

const formStrucPruefAssistenz = () => {
	// autofold/fold_next
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausgangssituation_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc = () => {
	// autofold/fold_next

	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0013878803_abentraeger_Auftraggeber_Etc,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0228680819_ge_Einsatzgebiete_Linien_Etc,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0163671123_off_Werkstattausruestung_Etc,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0249247459_nien_Tagesfahrleistungen_Etc,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Projektbeschreibung_Elek_0142209667_werblichen_Vergabeverfahrens,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucAusgangssituationAntragEbusseNachruestung = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausgangssituation_Pruefstatus.path,
			P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausgangssituation_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), formStruc());
	return concat(formStruc());
};
